import {FC} from "react";
import {useTranslation} from "react-i18next";
import styled from "@emotion/styled";
import {IPlayer} from "modules/types";
import {getPlayerStats, getStatsValue} from "modules/utils";
import {OverviewItemWrapper, OverviewWrapper} from "./common";
import {breakpoints} from "assets/theme";

const Value = styled.div`
	font-weight: 700;
	font-size: 20px;
	line-height: 120%;
	letter-spacing: 0.2px;

	@media (min-width: ${breakpoints.medium}) {
		font-size: 24px;
	}
`;

const Name = styled.div`
	font-family: "Hind", sans-serif;
	font-weight: 400;
	font-size: 12px;
	line-height: 120%;
	letter-spacing: 0.02em;
`;

interface IStatItem {
	value: string | number;
	name: string;
}

const StatItem: FC<IStatItem> = ({value, name}) => (
	<OverviewItemWrapper>
		<Value>{value}</Value>
		<Name>{name}</Name>
	</OverviewItemWrapper>
);

interface IOverview {
	player: IPlayer;
}

export const PlayerOverview: FC<IOverview> = ({player}) => {
	const {t} = useTranslation();
	const stats = getPlayerStats(player);

	if (!stats) {
		return null;
	}

	return (
		<OverviewWrapper>
			{stats.map(({value, key, isShowDecimal}) => (
				<StatItem key={key} value={getStatsValue(value, isShowDecimal)} name={t(key)} />
			))}
		</OverviewWrapper>
	);
};
